export const loadHeadScripts = (scriptUrls) => {
    scriptUrls.forEach((url) => {
        const script = document.createElement("script");
        script.src = url;
        script.async = true;
        document.head.appendChild(script);

        return () => document.head.removeChild(script);
    });
};
